    import { faGithub, faLinkedin, faTwitter, faFacebook, faXTwitter } from "@fortawesome/free-brands-svg-icons";

    export const socialLinks = [
        { icon: faGithub, to: "https://github.com/brelnosse" },
        { icon: faLinkedin, to: "https://www.linkedin.com/in/brel-nosse-88a3a2377/" },
        { icon: faXTwitter, to: "https://x.com/BrelNosse" },
        { icon: faFacebook, to: "https://www.facebook.com/profile.php?id=61568437907463" }
    ];